import { useQuery } from "@tanstack/react-query";
import { fetchGamificationCoinStore } from "../services/gamificationService";

function normalizeCoinPack(item) {
  const amount = Number(item?.amount || 0);
  const discountedPrice = Number(item?.discounted_price || 0);
  const discountPercent =
    amount > 0 && discountedPrice >= 0
      ? Math.max(0, Math.round(((amount - discountedPrice) / amount) * 100))
      : 0;

  return {
    id: Number(item?.id || 0),
    coins: Number(item?.coins || 0),
    amount,
    discountedPrice,
    discountPercent,
    raw: item,
  };
}

export function useGamificationCoinStore(options = {}) {
  return useQuery({
    queryKey: ["gamificationCoinStore"],
    queryFn: async () => {
      const { payload } = await fetchGamificationCoinStore();

      return {
        currentCoins: Number(payload?.current_coins || 0),
        rewardedAdsEnabled: [true, 1, '1'].includes(payload?.rewarded_ads_enabled),
        coinsPerAd: Number(payload?.coins_per_ad || 0),
        coinsList: Array.isArray(payload?.coins_list)
          ? payload.coins_list.map(normalizeCoinPack)
          : [],
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        currentCoins: 0,
        rewardedAdsEnabled: false,
        coinsPerAd: 0,
        coinsList: [],
      },
  });
}
